const Validator = {  
  /*手机号字符串校验，返回true/false*/  
  isPhone(str) {  
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/  
    return reg.test(str)  
  },  
  /*获取elem手机规则校验器*/  
  getPhoneValidator(){  
    var validPhone=(rule, value,callback)=>{  
        if (!value){  
            callback(new Error('请输入手机号码'))  
        }else  if (!Validator.isPhone(value)){  
          callback(new Error('请输入正确的11位手机号码'))  
        }else {  
            callback()  
        }  
    }  
    return validPhone  
  },
}  
/*转换*/
const convert = {
  fmtDate(obj){  /*转换时间戳*/
    var date =  new Date(obj);
    var y = 1900+date.getYear();
    var m = "0"+(date.getMonth()+1);
    var d = "0"+date.getDate();
    return y+"-"+m.substring(m.length-2,m.length)+"-"+d.substring(d.length-2,d.length);
  }
}
/*每个页面获取button 权限对象*/
const getAuthorityj = {
  getObj (menu) {
    let arr = JSON.parse(sessionStorage.getItem(menu))
    let obj = {  //默认全禁用
      button181: true,  //查询
      button182: true,  //添加
      button183: true,  //编辑
      button184: true,  //删除
      button185: true,  //启用
      button186: true,  //禁用
      button187: true,  //审核
      button188: true,  //上传
      button213: true,  //下载
    };
    if (arr.length > 0) {
      arr.map(button_item => {
        obj['button'+button_item.id] = false
      })
    }
    return obj;
  }
}
/*校验开始时间要小于结束时间*/
const comparison = {
  time(startTime,endTime,field){ /*startTime 开始时间 endTime 结束时间  filed分隔符*/
    if (startTime.length > 0 && endTime.length > 0) {
      var startTmp = startTime.split(field);
      var endTmp = endTime.split(field);
      var sd = new Date(startTmp[0], startTmp[1], startTmp[2]);
      var ed = new Date(endTmp[0], endTmp[1], endTmp[2]);
      if (sd.getTime() > ed.getTime()) {
          return false;
      }
    }
    return true;
  }
}

// 对Validator的实例重新封装成一个plugin ,方便 Vue.use(xxxx)  
export default {  
  install: function(Vue, Option) {  
    Object.defineProperty(Vue.prototype, "$valid", { value: Validator });  
    Object.defineProperty(Vue.prototype, "$convert", { value: convert });
    Object.defineProperty(Vue.prototype,'$buttonPower',{ value: getAuthorityj });
    Object.defineProperty(Vue.prototype,'$comparison',{ value: comparison })
  }  
};  


// WEBPACK FOOTER //
// ./src/components/regValidate/validate.js